import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import ActionLog from "@/pages/ActionLog";
import Failures from "@/pages/Failures";
import Review from "@/pages/Review";
import Workflows from "@/pages/Workflows";
import Receipt from "@/pages/Receipt";
import ChiroTracker from "@/pages/ChiroTracker";
import ProspectReceipt from "@/pages/ProspectReceipt";
import Login from "@/pages/Login";
import MasterCampaign from "@/pages/MasterCampaign";
import VerticalTrackers from "@/pages/VerticalTrackers";
import VerticalTrackerDetail from "@/pages/VerticalTrackerDetail";
import Campaigns from "@/pages/Campaigns";
import CampaignDetail from "@/pages/CampaignDetail";
import Prospects from "@/pages/Prospects";
import Approvals from "@/pages/Approvals";
import OutreachQueue from "@/pages/OutreachQueue";
import Receipts from "@/pages/Receipts";
import Settings from "@/pages/Settings";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        {/* Login is the only unauthenticated route */}
                        <Route path="/login" element={<Login />} />

                        {/* Everything else requires auth */}
                        <Route
                            element={
                                <ProtectedRoute>
                                    <Layout />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="/" element={<Navigate to="/dashboard" replace />} />
                            <Route path="/dashboard" element={<Dashboard />} />

                            {/* v2 — primary command center */}
                            <Route path="/master-campaign" element={<MasterCampaign />} />
                            <Route path="/vertical-trackers" element={<VerticalTrackers />} />
                            <Route
                                path="/vertical-trackers/:id"
                                element={<VerticalTrackerDetail />}
                            />
                            <Route path="/campaigns" element={<Campaigns />} />
                            <Route path="/campaigns/:id" element={<CampaignDetail />} />
                            <Route path="/prospects" element={<Prospects />} />
                            <Route path="/approvals" element={<Approvals />} />
                            <Route path="/outreach-queue" element={<OutreachQueue />} />
                            <Route path="/receipts" element={<Receipts />} />
                            <Route path="/settings" element={<Settings />} />

                            {/* Existing observability + legacy ChiroTracker */}
                            <Route path="/log" element={<ActionLog />} />
                            <Route path="/failures" element={<Failures />} />
                            <Route path="/review" element={<Review />} />
                            <Route path="/workflows" element={<Workflows />} />
                            <Route path="/chirotracker" element={<ChiroTracker />} />
                            <Route path="/prospects/:id/receipt" element={<ProspectReceipt />} />
                        </Route>

                        {/* Public action receipt also gated now per security request.
                            The page itself fetches /api/receipts/{id} which is now 401
                            without auth, so we wrap it too. */}
                        <Route
                            path="/r/:id"
                            element={
                                <ProtectedRoute>
                                    <Receipt />
                                </ProtectedRoute>
                            }
                        />

                        {/* Catch-all → login */}
                        <Route path="*" element={<Navigate to="/login" replace />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
            <Toaster
                position="bottom-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#111315",
                        border: "1px solid #262a2e",
                        color: "#f3f4f6",
                        borderRadius: "2px",
                        fontFamily: "IBM Plex Mono, monospace",
                        fontSize: "12px",
                    },
                }}
            />
        </div>
    );
}

export default App;
